import type { RootState } from 'src/store';
import { connect } from 'react-redux';

import { getActiveSurfaceName, getDecorationSpecs, getSurfaceProperties } from 'src/selectors/pages/editor';

import decorationSpecs from './decorationSpecs';

const mapStateToProps = (state: RootState) => {
    const { isLoading, decorationPlacement, printWhite, sizeChart, decorationMissingSelections } =
        getDecorationSpecs(state);
    const { merchantVariables } = getSurfaceProperties(state);

    return {
        isLoading,
        decorationPlacement,
        printWhite,
        sizeChart,
        decorationMissingSelections,
        currentSize: merchantVariables?.Size,
        activeSurfaceName: getActiveSurfaceName(state),
    };
};

const decorationSpecsContainer = connect(mapStateToProps, {})(decorationSpecs);

export default decorationSpecsContainer;
